module.exports = __webpack_public_path__ + "img/logo8.d5d9ddf9.jpg";